<template>
  <div class="container" style="position: relative; z-index: 150;">

    <router-link class="navbar-brand" to="/">
      <img src="@/assets/images/logo_white.png" />
    </router-link>

    <div class="volume">
      <i class="fad" :class="{ 'active fa-volume': !sound.muted, 'fa-volume-mute': sound.muted }" v-on:click="toggleSound()"></i>
      <div class="control">
        <vue-slider ref="volume" direction="btt" :height="100" :tooltip-formatter="'{value}%'" v-model="volume"></vue-slider>
      </div>
    </div>

    <!--
    <div class="elytra-warning ml-3 text-warning">
      <i class="fad fa-exclamation-triangle"></i>
    </div>
    -->

    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse" id="navbarSupportedContent" style="z-index: 10; position: relative;">
      <ul class="navbar-nav ml-auto align-items-center">

        <li class="nav-item" :class="{ active: this.$route.name == 'Map' }">
          <router-link class="nav-link" to="/kart">Kart</router-link>
        </li>

        <li class="nav-item" :class="{ active: this.$route.name == 'Chat' }">
          <router-link class="nav-link" to="/chat">
            Chat
            <i class="nav-alert" v-if="chatUnread"></i>
          </router-link>
        </li>

        <li class="nav-item dropdown" :class="{ show: dropdown === 'games', active: getPage('spill', 0) }" v-on:click.prevent.stop="setDropdown('games')" v-on-clickaway="setDropdown">
          <a class="nav-link dropdown-toggle" href="/spill">
            Spill
          </a>

          <transition
            name="custom-classes-transition"
            enter-active-class="animate__animated animate__zoomIn animate__faster"
            leave-active-class="animate__animated animate__zoomOut animate__faster"
          >
            <div class="dropdown-menu dropdown-menu-right" v-show="dropdown === 'games'">
              <router-link class="dropdown-item d-flex align-items-center" :class="{ active: getPage('blackjack', 1) }" to="/spill/blackjack">
                <div class="icon"><i class="fad fa-spade"></i></div>
                <div class="info">
                  <strong>Blackjack</strong>
                  <small>Litt for mange EC? Prøv deg på Blackjack, vinn eller forsvinn!</small>
                </div>
              </router-link>

              <router-link class="dropdown-item d-flex align-items-center" :class="{ active: getPage('roulette', 1) }" to="/spill/roulette">
                <div class="icon"><i class="fad fa-dice"></i></div>
                <div class="info">
                  <strong>Roulette</strong>
                  <small>Rød, svart eller grønn? Hva vedder du og på hva?</small>
                </div>
              </router-link>
              <!--
              <router-link class="dropdown-item d-flex align-items-center" :class="{ active: getPage('minebros', 1) }" to="/spill/minebros">
                <div class="icon"><i class="fad fa-dice"></i></div>
                <div class="info">
                  <strong>Super Minecraft Bros</strong>
                  <small>Hvor mange nivåer, EC, dia og emeralder klarer du og oppnå?</small>
                </div>
              </router-link>

              <router-link class="dropdown-item d-flex align-items-center" to="/spill/sjakk">
                <div class="icon"><i class="fad fa-chess"></i></div>
                <div class="info">
                  <strong>Sjakk</strong>
                  <small>Spill mot andre Elytra spillere i sjakk. Vinneren tar hele gevinsten.</small>
                </div>
              </router-link>
              -->
            </div>
          </transition>
        </li>

        <li class="nav-item dropdown" :class="{ show: dropdown === 'elytra', active: getPage('søknader', 0) || getPage('regler', 0) || getPage('staff', 0) }" v-on:click.prevent.stop="setDropdown('elytra')" v-on-clickaway="setDropdown">
          <a class="nav-link dropdown-toggle" href="/elytra">
            Elytra
          </a>

          <transition
            name="custom-classes-transition"
            enter-active-class="animate__animated animate__zoomIn animate__faster"
            leave-active-class="animate__animated animate__zoomOut animate__faster"
          >
            <div class="dropdown-menu dropdown-menu-right" v-show="dropdown === 'elytra'" :class="{ active: getPage('søknader', 0) || getPage('regler', 0) || getPage('staff', 0) }">
              <!--
              <router-link class="dropdown-item d-flex align-items-center" :class="{ active: getPage('søknader', 0) }" to="/søknader">
                <div class="icon"><i class="fad fa-file-user"></i></div>
                <div class="info">
                  <strong>Søknader</strong>
                  <small>Lyst til og bli en del av staff? Eller vil du heller bestemme?</small>
                </div>
              </router-link>
              -->

              <router-link class="dropdown-item d-flex align-items-center" :class="{ active: getPage('regler', 0) }" to="/regler">
                <div class="icon"><i class="fad fa-fist-raised"></i></div>
                <div class="info">
                  <strong>Regler</strong>
                  <small>Vi har noen enkle regler på Elytra. Følg dem !</small>
                </div>
              </router-link>

              <!--
              <router-link class="dropdown-item d-flex align-items-center" to="/">
                <div class="icon"><i class="fad fa-pastafarianism"></i></div>
                <div class="info">
                  <strong>Ønskeliste og bugs</strong>
                  <small>Funnet en feil? Noe du savner? Fortell oss om det og bli belønnet med EC!</small>
                </div>
              </router-link>
              -->

              <router-link class="dropdown-item d-flex align-items-center" :class="{ active: getPage('staff', 0) }" to="/staff">
                <div class="icon"><i class="fad fa-users-crown"></i></div>
                <div class="info">
                  <strong>Staff oversikt</strong>
                  <small>Se hvem som gjør hva innad i Elytra.</small>
                </div>
              </router-link>
            </div>
          </transition>
        </li>

        <li class="nav-item dropdown" :class="{ show: dropdown === 'statistics', active: getPage('statistikk', 0) }" v-on:click.prevent.stop="setDropdown('statistics')" v-on-clickaway="setDropdown">
          <a class="nav-link dropdown-toggle" href="/statistikk">
            Statistikk
          </a>

            <transition
              name="custom-classes-transition"
              enter-active-class="animate__animated animate__zoomIn animate__faster"
              leave-active-class="animate__animated animate__zoomOut animate__faster"
            >
              <div class="dropdown-menu dropdown-menu-right" v-show="dropdown === 'statistics'">
                <router-link class="dropdown-item d-flex align-items-center" :class="{ active: getPage('statistikk', 0) && !getPage('ec', 1) }" to="/statistikk">
                  <div class="icon"><i class="fad fa-trophy"></i></div>
                  <div class="info">
                    <strong>Statistikk</strong>
                    <small>Hvor mange ganger har noen hoppet? Eller tømt en bøtte?</small>
                  </div>
                </router-link>

                <router-link class="dropdown-item d-flex align-items-center" :class="{ active: getPage('statistikk', 0) && getPage('ec', 1) }" to="/statistikk/ec">
                  <div class="icon"><i class="fad fa-money-bill-wave"></i></div>
                  <div class="info">
                    <strong>Elytra coins</strong>
                    <small>Hva er det brukt EC på og hvor i huleste kommer EC fra?</small>
                  </div>
                </router-link>
              </div>
          </transition>
        </li>

        <li class="nav-item dropdown" :class="{ show: dropdown === 'help', active: getPage('hjelp', 0) }" v-on:click.prevent.stop="setDropdown('help')" v-on-clickaway="setDropdown">
          <a class="nav-link dropdown-toggle" href="/hjelp">
            Hjelp
          </a>

          <transition
            name="custom-classes-transition"
            enter-active-class="animate__animated animate__zoomIn animate__faster"
            leave-active-class="animate__animated animate__zoomOut animate__faster"
          >
            <div class="dropdown-menu dropdown-menu-right" v-show="dropdown === 'help'">
              <router-link class="dropdown-item d-flex align-items-center" :class="{ active: getPage('hjelp', 0) && !getPage('kommandoer', 1) }" to="/hjelp">
                <div class="icon"><i class="fad fa-exclamation-triangle"></i></div>
                <div class="info">
                  <strong>Dokumentasjon</strong>
                  <small>Ofte stilte spørsmål og dokumentasjon på hvorfor ting er som dem er eller hvordan det virker i praksis.</small>
                </div>
              </router-link>

              <router-link class="dropdown-item d-flex align-items-center" :class="{ active: getPage('hjelp', 0) && getPage('kommandoer', 1) }" to="/hjelp/kommandoer">
                <div class="icon"><i class="fad fa-terminal"></i></div>
                <div class="info">
                  <strong>Kommandoer</strong>
                  <small>En oversikt over alle kommandoer du kan utføre på Elytra sine servere.</small>
                </div>
              </router-link>
            </div>
          </transition>
        </li>

        <!--
        <li class="nav-item" :class="{ active: this.$route.name == 'Shop' }">
          <router-link class="nav-link" to="/butikk">Butikk</router-link>
        </li>
        -->

        <li class="nav-item dropdown" :class="{ show: dropdown === 'highscore', active: getPage('highscore', 0) }" v-on:click.prevent.stop="setDropdown('highscore')" v-on-clickaway="setDropdown">
          <a class="nav-link" href="/highscore">
            <i class="fad fa-crown"></i>
          </a>

          <transition
            name="custom-classes-transition"
            enter-active-class="animate__animated animate__zoomIn animate__faster"
            leave-active-class="animate__animated animate__zoomOut animate__faster"
          >
            <div class="dropdown-menu dropdown-menu-right" v-show="dropdown === 'highscore'">
              <!--
              <router-link class="dropdown-item d-flex align-items-center" to="/highscore">
                <div class="icon"><i class="fad fa-trophy"></i></div>
                <div class="info">
                  <strong>Highscore</strong>
                  <small>Topplisten over alle spillere fordelt på alle servere.</small>
                </div>
              </router-link>
              -->

              <router-link class="dropdown-item d-flex align-items-center" :class="{ active: getPage('highscore', 0) && getPage('ec', 1) }" to="/highscore/ec">
                <div class="icon"><i class="fad fa-alien-monster"></i></div>
                <div class="info">
                  <strong>Elytra coins</strong>
                  <small>Hvem er rikest eller fattigst? Se kongene av EC.</small>
                </div>
              </router-link>

              <router-link class="dropdown-item d-flex align-items-center" :class="{ active: getPage('highscore', 0) && getPage('parkour', 1) }" to="/highscore/parkour">
                <div class="icon"><i class="fad fa-running"></i></div>
                <div class="info">
                  <strong>Parkour</strong>
                  <small>Hoppedy hopp! Speil speil på veggen der, hvem er beste hoppern her.</small>
                </div>
              </router-link>

              <!--
              <router-link class="dropdown-item d-flex align-items-center" to="/highscore/minecraft">
                <div class="icon"><i class="fad fa-shovel"></i></div>
                <div class="info">
                  <strong>Blokker & Mining</strong>
                  <small>Hvem har minet flest blokker, drept flest kyllinger eller sprengt flest Creepere?</small>
                </div>
              </router-link>
              -->
            </div>
          </transition>
        </li>

        <li class="nav-item" v-if="!user.uuid">
          <button class="btn btn-light" v-on:click="openModal({ id: 'login' })">Logg inn</button>
        </li>

        <li class="nav-item nav-user dropdown" :class="{ show: dropdown === 'user' }" v-on:click.stop="setDropdown('user')" v-if="user.uuid" v-on-clickaway="setDropdown">
          <a class="nav-link d-flex align-items-center" href="/konto" v-on:click.prevent>
            <img :src="getPlayerSkin(user.uuid, 26)" />
            <div class="nav-user-details">
              <strong class="d-block">{{ user.name }}</strong>
              <small class="text-success d-block"><a-number :value="user.balance" :round="true" :formatValue="format_ecs" /></small>
            </div>
          </a>

          <transition
            name="custom-classes-transition"
            enter-active-class="animate__animated animate__zoomIn animate__faster"
            leave-active-class="animate__animated animate__zoomOut animate__faster"
          >
            <div class="dropdown-menu dropdown-menu-right dropdown-menu-user" v-show="dropdown === 'user'">
              <div class="nav-user-dropdown-header">
                <div class="row">
                  <div class="col">
                    <img :src="getPlayerSkin(user.uuid, 50, 'bust')" />
                  </div>
                  <div class="col-9">
                    <div class="d-flex">
                      <strong class="flex-fill">Hovedrolle:</strong> <span v-if="user.role.name" :class="{ [`mc-text-${user.role.meta.color}`]: user.role.meta.color }">{{ user.role.name }}</span> <small v-if="!user.role.name">Ingen rolle</small>
                    </div>

                    <div class="d-flex" v-if="user.achievements">
                      <strong class="flex-fill">Achievements:</strong> {{ user.achievements.completed }}
                    </div>

                    <div class="d-flex" v-if="user.statistics">
                      <strong class="flex-fill">Spilletid:</strong> {{ user.statistics.time_played.friendly.short }}
                    </div>

                    <hr />

                    <strong>Balanse</strong>
                    <p class="lead text-success mb-0"><a-number :value="user.balance" :round="true" :formatValue="format_ec" /> EC</p>

                    <div v-if="user.expenses.properties">
                      <strong class="mt-3 d-block">Daglige utgifter</strong>
                      <p class="lead text-danger mb-0"><a-number :value="user.expenses.properties" :round="true" :formatValue="format_ec" /> EC</p>
                    </div>

                  </div>
                </div>
              </div>

              <router-link class="dropdown-item" :to="'/spillere/' + user.name">Min profil</router-link>
              <router-link class="dropdown-item" to="/konto/personvern">Innstillinger</router-link>

              <a class="dropdown-divider" style="height: 3px; display: block; background-color: #eee;"></a>

              <router-link class="dropdown-item" to="/innstillinger" v-if="hasPermission('mineland.admin')">Administrasjon</router-link>
              <router-link class="dropdown-item" to="/konto/ut">Logg ut</router-link>

            </div>
          </transition>
        </li>

      </ul>
    </div>

  </div>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway'
import VueSlider from 'vue-slider-component'
import { mapActions, mapState } from 'vuex'

import User from '@/mixins/user'
import Filters from '@/mixins/filters'

export default {
  name: 'Navbar',
  mixins: [User, Filters, clickaway],

  data: function() {
    return {
      dropdown: null
    }
  },

  components: {
    VueSlider
  },

  computed: {
    ...mapState({
      user: state => state.user,
      sound: state => state.sound,
      chatUnread: state => state.chat.unread
    }),

    volume: {
      get() {
        return this.sound.volume
      },

      set(volume) {
        this.$store.dispatch('setVolume', volume)
      }
    }
  },

  props: {
    logo: {
      type: String,
      default: 'white'
    },

    padding: {
      type: String,
      default: '15px'
    }
  },

  methods: {
    ...mapActions([
      'openModal',
      'toggleSound'
    ]),

    isPattern(pattern) {
      if (this.pattern === pattern) return true
      return false
    },

    setDropdown(dropdown) {
      if (!dropdown) this.dropdown = null
      if (this.dropdown === dropdown) return this.dropdown = null
      this.dropdown = dropdown
    },

    getPage(fragment, index) {
      const p = this.$router.currentRoute
      const s = p.path.replace(/^\//, '').split('/')

      if (s[index] === fragment) return true
      return false
    }
  }
}
</script>

<style lang="scss">
@import '~vue-slider-component/theme/antd.css';
</style>
